import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import CompanyData from './CompanyData';

Vue.use(Vuex);

export default new Vuex.Store({

  state: {
    contacts: [],
    offices: [],
    name: '',
    district: '',
    companyData: new CompanyData,
    count: 0,
    error: null,
    isLoading: false,
    searched: 0,
  },

  getters: {
    searchCount(state) {
      return state.searched;
    },
    isLoading(state) {
      return state.isLoading;
    },
    error(state) {
      return state.error;
    },
    count(state) {
      return state.count;
    },
    companyName(state) {
      return state.name;
    },
    district(state) {
      return state.district;
    },
    changedValues(state) {
      return state.companyData;
    },
    contactsByDistrict(state) {
      if (state.contacts) {
        return state.contacts.filter((contact) => {
          return contact.district.toLowerCase() ===
            state.district.toLowerCase();
        });
      }
    },
    officesByDistrict(state) {
      if (state.offices) {
        return state.offices.filter((office) => {
          return office.district.toLowerCase() === state.district.toLowerCase();
        });
      }
    },
  },

  mutations: {
    setLoading(state, boolean) {
      state.isLoading = boolean;
    },
    increment(state) {
      state.count++;
    },
    setData(state, data) {
      state.contacts = data.contacts;
      state.offices = data.offices;
    },
    setCompanyName(state, name) {
      state.name = name;
    },
    setDistrict(state, district) {
      state.district = district;
    },
    setNewData(state, params) {
      if (state.companyData[params.type]['removed'][params.id] &&
        !params.isRemove) {
        delete state.companyData[params.type]['removed'][params.id];
      }
      if (params.isRemove) {
        state.companyData[params.type]['removed'][params.id] = params.changedValues;
      }
      else if (params.isNew) {
        state.companyData[params.type]['added'][params.id] = params.changedValues;
      }
      else {
        if (Object.keys(params.changedValues.oldValues).length === 0) {
          delete state.companyData[params.type]['changed'][params.id];
        }
        else {
          state.companyData[params.type]['changed'][params.id] = params.changedValues;
        }
      }
    },
    addData(state, data) {
      state[data.type].push(data.values);
    },
    addError(state, error) {
      state.error = error;
    },
    searched(state) {
      state.searched++;
    }
  },

  actions: {
    getCompanyData(context, params) {
      axios.get(
        `https://luotettavatrakentajat.fi/api/company/FI/${params.businessId}/`).
        then((response) => {
          context.commit('searched');
          context.commit('setLoading', true);
          context.commit('addError', null);
          context.commit('setCompanyName', null);
          context.commit('setData', { contacts: null, offices: null });

          context.commit('setCompanyName', response.data.name);
          context.commit('setDistrict', params.district);
          setTimeout(() => {
            context.commit('setData', response.data);
            context.commit('setLoading', false);
          }, 100);
        }).
        catch((error) => {
          if (error.response.status === 404) {
            context.commit('addError', {
              text: 'Haku ei tuottanut yhtään tulosta',
              status: 404,
            });
            context.commit('setLoading', false);
          }
        });
    },
    setNewData(context, params) {
      context.commit('setNewData', params);
    },
    addData(context, data) {
      context.commit('addData', data);
    },
  },

});



// WEBPACK FOOTER //
// ./src/store.js